/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LadderChallengeStatus } from './LadderChallengeStatus';
import {
    LadderChallengeStatusFromJSON,
    LadderChallengeStatusFromJSONTyped,
    LadderChallengeStatusToJSON,
    LadderChallengeStatusToJSONTyped,
} from './LadderChallengeStatus';

/**
 * A challenge between two ladder participants
 * @export
 * @interface LadderChallenge
 */
export interface LadderChallenge {
    /**
     * 
     * @type {string}
     * @memberof LadderChallenge
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof LadderChallenge
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof LadderChallenge
     */
    updatedAt: number;
    /**
     * ID of the ladder
     * @type {string}
     * @memberof LadderChallenge
     */
    ladderId: string;
    /**
     * Challenger's odId
     * @type {string}
     * @memberof LadderChallenge
     */
    challengerOdId: string;
    /**
     * 
     * @type {string}
     * @memberof LadderChallenge
     */
    challengerDisplayName: string;
    /**
     * Challenger's rank at time of challenge
     * @type {number}
     * @memberof LadderChallenge
     */
    challengerRank: number;
    /**
     * Challenger's rating at time of challenge
     * @type {number}
     * @memberof LadderChallenge
     */
    challengerRating: number;
    /**
     * Defender's odId
     * @type {string}
     * @memberof LadderChallenge
     */
    defenderOdId: string;
    /**
     * 
     * @type {string}
     * @memberof LadderChallenge
     */
    defenderDisplayName: string;
    /**
     * Defender's rank at time of challenge
     * @type {number}
     * @memberof LadderChallenge
     */
    defenderRank: number;
    /**
     * Defender's rating at time of challenge
     * @type {number}
     * @memberof LadderChallenge
     */
    defenderRating: number;
    /**
     * ID of the shared Match document (created when ACCEPTED)
     * @type {string}
     * @memberof LadderChallenge
     */
    matchId?: string;
    /**
     * 
     * @type {LadderChallengeStatus}
     * @memberof LadderChallenge
     */
    status: LadderChallengeStatus;
    /**
     * 
     * @type {number}
     * @memberof LadderChallenge
     */
    scheduledTime?: number;
    /**
     * Deadline for the defender to accept (epoch ms)
     * @type {number}
     * @memberof LadderChallenge
     */
    mustAcceptBy: number;
    /**
     * Deadline to complete the match (epoch ms)
     * @type {number}
     * @memberof LadderChallenge
     */
    mustCompleteBy?: number;
    /**
     * 
     * @type {number}
     * @memberof LadderChallenge
     */
    acceptedAt?: number;
    /**
     * When the Match completed (denormalized from Match)
     * @type {number}
     * @memberof LadderChallenge
     */
    completedAt?: number;
    /**
     * Winner's odId (denormalized from Match)
     * @type {string}
     * @memberof LadderChallenge
     */
    winnerOdId?: string;
    /**
     * 
     * @type {number}
     * @memberof LadderChallenge
     */
    challengerRatingChange?: number;
    /**
     * 
     * @type {number}
     * @memberof LadderChallenge
     */
    defenderRatingChange?: number;
    /**
     * Decline reason (only for DECLINED status)
     * @type {string}
     * @memberof LadderChallenge
     */
    declineReason?: string;
}



/**
 * Check if a given object implements the LadderChallenge interface.
 */
export function instanceOfLadderChallenge(value: object): value is LadderChallenge {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('ladderId' in value) || value['ladderId'] === undefined) return false;
    if (!('challengerOdId' in value) || value['challengerOdId'] === undefined) return false;
    if (!('challengerDisplayName' in value) || value['challengerDisplayName'] === undefined) return false;
    if (!('challengerRank' in value) || value['challengerRank'] === undefined) return false;
    if (!('challengerRating' in value) || value['challengerRating'] === undefined) return false;
    if (!('defenderOdId' in value) || value['defenderOdId'] === undefined) return false;
    if (!('defenderDisplayName' in value) || value['defenderDisplayName'] === undefined) return false;
    if (!('defenderRank' in value) || value['defenderRank'] === undefined) return false;
    if (!('defenderRating' in value) || value['defenderRating'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('mustAcceptBy' in value) || value['mustAcceptBy'] === undefined) return false;
    return true;
}

export function LadderChallengeFromJSON(json: any): LadderChallenge {
    return LadderChallengeFromJSONTyped(json, false);
}

export function LadderChallengeFromJSONTyped(json: any, ignoreDiscriminator: boolean): LadderChallenge {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'ladderId': json['ladderId'],
        'challengerOdId': json['challengerOdId'],
        'challengerDisplayName': json['challengerDisplayName'],
        'challengerRank': json['challengerRank'],
        'challengerRating': json['challengerRating'],
        'defenderOdId': json['defenderOdId'],
        'defenderDisplayName': json['defenderDisplayName'],
        'defenderRank': json['defenderRank'],
        'defenderRating': json['defenderRating'],
        'matchId': json['matchId'] == null ? undefined : json['matchId'],
        'status': LadderChallengeStatusFromJSON(json['status']),
        'scheduledTime': json['scheduledTime'] == null ? undefined : json['scheduledTime'],
        'mustAcceptBy': json['mustAcceptBy'],
        'mustCompleteBy': json['mustCompleteBy'] == null ? undefined : json['mustCompleteBy'],
        'acceptedAt': json['acceptedAt'] == null ? undefined : json['acceptedAt'],
        'completedAt': json['completedAt'] == null ? undefined : json['completedAt'],
        'winnerOdId': json['winnerOdId'] == null ? undefined : json['winnerOdId'],
        'challengerRatingChange': json['challengerRatingChange'] == null ? undefined : json['challengerRatingChange'],
        'defenderRatingChange': json['defenderRatingChange'] == null ? undefined : json['defenderRatingChange'],
        'declineReason': json['declineReason'] == null ? undefined : json['declineReason'],
    };
}

export function LadderChallengeToJSON(json: any): LadderChallenge {
    return LadderChallengeToJSONTyped(json, false);
}

export function LadderChallengeToJSONTyped(value?: LadderChallenge | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'ladderId': value['ladderId'],
        'challengerOdId': value['challengerOdId'],
        'challengerDisplayName': value['challengerDisplayName'],
        'challengerRank': value['challengerRank'],
        'challengerRating': value['challengerRating'],
        'defenderOdId': value['defenderOdId'],
        'defenderDisplayName': value['defenderDisplayName'],
        'defenderRank': value['defenderRank'],
        'defenderRating': value['defenderRating'],
        'matchId': value['matchId'],
        'status': LadderChallengeStatusToJSON(value['status']),
        'scheduledTime': value['scheduledTime'],
        'mustAcceptBy': value['mustAcceptBy'],
        'mustCompleteBy': value['mustCompleteBy'],
        'acceptedAt': value['acceptedAt'],
        'completedAt': value['completedAt'],
        'winnerOdId': value['winnerOdId'],
        'challengerRatingChange': value['challengerRatingChange'],
        'defenderRatingChange': value['defenderRatingChange'],
        'declineReason': value['declineReason'],
    };
}

